<template>
  <div id="ApplyNotice">
    <div class="Textpara">
      <p class="Textaction">申请须知</p>
      <p class="Textaction">一、申请条件</p>
      <p class="TextInfo">1、 申请人需为被监护未成年人的法定监护人；</p>
      <p class="TextInfo">2、 申请人的被监护人年龄小于18周岁；</p>
      <p class="TextInfo">3、 申请人需为大陆公民，不含港、澳、台人士。</p>
      <p class="Textaction">二、申请需要提交材料：</p>
      <p class="TextInfo">1、监护人信息表（包含监护人的身份证及户口本复印件）；</p>
      <p class="TextInfo">2、被监护人信息表（包含被监护人所玩游戏相关信息及户口本复印件）；</p>
      <p class="TextInfo">3、填写网络游戏未成年人家长监护工程申请书、保证书、授权书并手工签字；</p>
      <p class="TextInfo">4、派出所/公安机关出示的监护关系证明书（非必要条件）。</p>
      <p class="Textaction">三、申请方式 您可以通过以下方式联系我们：</p>
      <p class="TextInfo">1、服务邮箱：service@racoondigi.com</p>
      <p class="TextInfo">2、直接到我们公司申请。地址：上海市闵行区莲花路1978号E103室</p>
      <p class="TextInfo">
        3、快件邮寄：地址：闵行区莲花路1978号E103室
        上海瑞酷数码科技有限公司 家长监护工程工程部 收
      </p>
      <p class="Textaction">四、申请流程：</p>
      <p
        class="TextInfo"
      >我公司在收到提交材料后，将在3个工作日内进行电话回访（不含法定节假日），并对内容进行核查。资料提交合格且核对正确的情况 下，由我公司对该请求予以受理；资料提交不全面的，由我公司进行回访，并提示申请人继续补充材料；资料提交不合格且不正确的，我公司有权对该请求予以拒 绝，并附说明理由。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "ApplyNotice",
  data() {
    return {};
  },
  components: {}
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';
</style>



// WEBPACK FOOTER //
// src/components/Custody/ApplyNotice.vue